// extracted by mini-css-extract-plugin
module.exports = {"informBlock":"informBlock_informBlock__1H6y7","icon":"informBlock_icon__3Exct"};